var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"m_section"},[_vm._m(0),_c('confirm')],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"contents"},[_c('h1')])
}]

export { render, staticRenderFns }